// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"117284f0","455":"dd2f79d7","977":"65540110"}[chunkId] + ".chunk.js";
};